import Top from '../models/top.es6';
import TopView from '../views/pages/topView.es6';
import TopBooks from '../views/pages/topBooks.es6';
export default class TopController {
    constructor() {
        this.top = new Top();
        this.topView = new TopView();
        this.topBooks = new TopBooks();
    }

    async setContent() {
        await this.top.getBooksData();
        const rebuildBooksData = this.top.getRebuildBooksData();
        this.topBooks.setEachLevelList(rebuildBooksData);
        this.topView.tab();
    }
}
